import C from './C';

function B (props){
    return(
        <C getNumber = {props.getNumber}/>
    ) 
}

export default B;